var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgData = function SvgData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m16.477 12.48-4.939-4.938 4.939-4.938 4.938 4.938zm-12.67-1.672v-7h7v7zm9.385 9.384v-7h7v7zm-9.384 0v-7h7v7zm1.5-10.884h4v-4h-4zm11.194 1.084 2.825-2.825-2.825-2.825-2.825 2.825zm-1.81 8.3h4v-4h-4zm-9.384 0h4v-4h-4z"
  })));
};
export default SvgData;